import { TenantBillingDetails, ITenant } from "../../../../../Admin/Tenants"
import { useOutletContext } from "react-router"
import { Helmet } from "react-helmet-async"

export default function TenantBillingDetailsPage() {
	const { tenant } = useOutletContext<{
		tenant: ITenant
		refresh: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Tenant Billings</title>
			</Helmet>
			<TenantBillingDetails tenantUid={tenant.uid} tenantId={tenant.id} />
		</>
	)
}
